import { render, staticRenderFns } from "./EmailLeftSidebar.vue?vue&type=template&id=7fbc51c2"
import script from "./EmailLeftSidebar.vue?vue&type=script&lang=js"
export * from "./EmailLeftSidebar.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports